
import { cioIdentify, cioTrackPageView } from './customerio';
import { mixpanelIdentify, mixpanelTrack } from './mixpanel';

declare global {
  interface Window {
    dataLayer: any;
  }
}

export function trackPageView(pathName: string) {
  cioTrackPageView(pathName);

  mixpanelTrack(EVENTS.PAGE_VIEW, {
    page: pathName,
  });
}

interface TrackData {
  userId?: string,
  email?: string,
  step?: SIGNUP_STEPS,
  transactionType?: TRANSACTION_TYPE,
  eventFields?: {}
}

export function trackEvent(event: EVENTS, data: TrackData) {
  mixpanelTrack(event);
  dataLayerTrack(event, data);
}

export const identify = (id: string) => {
  cioIdentify({ id });
  mixpanelIdentify(id);
};

function dataLayerTrack(event: EVENTS, data?: TrackData) {
  const dataLayer = window.dataLayer;
  if (typeof dataLayer != 'undefined') {
    dataLayer.push({
      event,
      userId: data?.userId,
      ...data
    });
  }
}


export enum EVENTS {
  TRADE_COMPLETE = 'trade_complete',
  RECURRING_BUY_CREATED = 'recurring_buy_created',
  LOGIN = 'login',
  REGISTER = 'register',
  PAGE_VIEW = 'page_view',
  REGISTRATION_COMPLETE = 'registration_complete',
  SIGNUP_COMPLETE = 'signup_complete',
  SHARE_REFER = 'share_refer',
  CRYPTO_WITHDRAWAL_CREATED = 'crypto_withdrawal_created',
  CRYPTO_DEPOSIT_CREATED = 'crypto_deposit_created',
  CRYPTO_DEPOSIT_STARTED = 'crypto_deposit_started',
  FIAT_WITHDRAWAL_CREATED = 'fiat_withdrawal_created',
  FIAT_DEPOSIT_CREATED = 'fiat_deposit_created',
  REFER_A_FRIEND = 'refer_a_friend',
  ADVERT_CLICK = 'advert_click',
  VERIFICATION_COMPLETE = 'verification_complete',
  VERIFICATION_PENDING = 'verification_pending',
}

export enum TRANSACTION_TYPE {
  INVEST = 'Invest',
  SELL = 'Sell',
  LOCK = 'Lock',
  UNLOCK = 'Lock',
  DEPOSIT = 'Deposit',
  WITHDRAW = 'Withdraw',
  RECURRING_BUY = 'Recurring Buy',
}

export const tradeEventFields = {
  amountFrom: 'Amount From',
  fromCurrencyCode: 'From currency',
  toAmountCrypto: 'Amount to',
  toCurrencyCode: 'To currency',
  tradeFees: 'Trade fees',
  feeCurrency: 'Fee currency',
  tradeType: 'Trade type',
  firstTrade: 'First trade',
  buyNow: 'Execute Immediately',
  schedule: 'Schedule',
};

export const transactionEventFields = {
  amount: 'Amount',
  currencyCode: 'Currency',
  fees: 'Fees',
  transactionType: 'Transaction type',
};

export const fundsEventFields = {
  productCode: 'Product Code',
  productName: 'Product Name',
  productCategory: 'Product Category',
};


export enum SIGNUP_STEPS {
  SIGN_UP = 'sign up',
  OTP = 'OTP',
  TERMS = 'terms & conditions',
  DASHBOARD = 'dashboard',
}
